import { FunctionComponent, useState } from "react";
import styles from "./NavigationBottomBar.module.css";
import MenuBottomBarBase, {
  MenuBottomBarBaseType,
} from "../../../../src/atoms/menu/bottom";

export type NavigationBottomBarType = {
  className?: string;
  onChange?: (item: MenuBottomBarBaseType) => void;
  items: MenuBottomBarBaseType[];
};

export const NavigationBottomBar: FunctionComponent<
  NavigationBottomBarType
> = ({ className = "", onChange, items = [] }) => {
  const [selected, setSelected] = useState(items[0]);
  const handleClick = (item: MenuBottomBarBaseType) => {
    setSelected(item);
    onChange?.(item);
  };

  return (
    <div
      className={[
        styles.typeiconOnly,
        "quill-ui-next-component",
        "quill-ui-next-no-select",
        className,
      ].join(" ")}
    >
      {items.map((item) => (
        <MenuBottomBarBase
          label={item?.label}
          icon={item?.icon}
          iconSelected={item?.iconSelected}
          onClick={() => handleClick(item)}
          state={selected === item ? "selected" : "default"}
          badgeLabel={item?.badgeLabel}
        />
      ))}
    </div>
  );
};

NavigationBottomBar.displayName = "NavigationBottomBar";

export default NavigationBottomBar;
